<div class="login-wrap">
  <button class="theme-toggle-fab" type="button" (click)="toggleTheme()" [title]="themeService.theme() === 'light' ? 'Dark mode' : 'Light mode'">
    {{ themeService.theme() === 'light' ? 'Dark mode' : 'Light mode' }}
  </button>
  <div class="card" *ngIf="!redirectingToHostedUi()">
    <header class="card-head">
      <h1>{{ showNewPasswordForm() ? 'Set new password' : 'Sign in' }}</h1>
      <p class="subtle">{{ showNewPasswordForm() ? 'Set a new password for your account' : 'Use your Cognito username or email' }}</p>
    </header>

    <form *ngIf="!showNewPasswordForm()" class="form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <div class="field">
        <label for="username">Username or email</label>
        <input
          id="username"
          type="text"
          formControlName="username"
          autocomplete="username"
          placeholder="you@example.com" />
      </div>
      <div class="field">
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          formControlName="password"
          autocomplete="current-password"
          placeholder="••••••••" />
      </div>
      <div class="field checkbox-field">
        <label>
          <input
            type="checkbox"
            formControlName="adminMode" />
          {{ 'login.logAsAdmin' | translate }}
        </label>
      </div>
      <button class="btn primary" type="submit" [disabled]="loading()">
        {{ loading() ? 'Signing in…' : 'Sign in' }}
      </button>
      <p class="form-error" *ngIf="error()">{{ error() }}</p>
    </form>

    <form *ngIf="showNewPasswordForm()" class="form" [formGroup]="newPasswordForm" (ngSubmit)="submitNewPassword()" novalidate>
      <div class="field">
        <label for="newPassword">New password</label>
        <input
          id="newPassword"
          type="password"
          formControlName="newPassword"
          autocomplete="new-password"
          placeholder="At least 8 characters, with upper, lower, and number" />
        <p class="field-hint" *ngIf="newPasswordForm.get('newPassword')?.invalid && newPasswordForm.get('newPassword')?.touched">
          At least 8 characters, including uppercase, lowercase, and a number (required by security policy).
        </p>
      </div>
      <div class="field">
        <label for="confirmPassword">Confirm new password</label>
        <input
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          autocomplete="new-password"
          placeholder="Repeat the new password" />
        <p class="field-hint" *ngIf="newPasswordForm.hasError('mismatch') && newPasswordForm.get('confirmPassword')?.touched">
          Passwords do not match
        </p>
      </div>
      <button class="btn primary" type="submit" [disabled]="loading() || newPasswordForm.invalid">
        {{ loading() ? 'Saving…' : 'Set password and sign in' }}
      </button>
      <button class="btn secondary" type="button" (click)="backToLogin()" [disabled]="loading()">
        Back
      </button>
      <p class="form-error" *ngIf="error()">{{ error() }}</p>
    </form>
  </div>
  <div class="card" *ngIf="redirectingToHostedUi()">
    <header class="card-head">
      <h1>Redirecting to sign in</h1>
      <p class="subtle">Taking you to the sign-in page…</p>
    </header>
  </div>
</div>
